// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"481":"84416f18","834":"84416f18"}[chunkId] + ".css";
};